// components/CancellationSuccessModal.tsx
import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { CircleCheck } from "lucide-react";
import { ButtonVariant, RegularButton } from "@/stories/button/button";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";

interface Props {
    onClose: () => void;
}

const CancelOrdersConfirmationModal: React.FC<Props> = ({ onClose }) => {
    return (
        <Dialog open={true}>
            <DialogDescription>Cancellation Success Modal</DialogDescription>
            <DialogContent className="flex flex-col w-[90%] !rounded-3xl py-8 md:min-h-[333px] md:w-[414px] [&>button:last-child]:hidden">
                <VisuallyHidden.Root>
                    <DialogTitle>Success Modal</DialogTitle>
                </VisuallyHidden.Root>
                <div className="w-full">
                    
                    <div className="flex w-full">
                        <CircleCheck className="m-auto h-[62px] w-[62px] text-orange-500" />
                    </div>
                    <div className="w-full text-center text-xl font-semibold">
                        {/* <div className="flex flex-col items-center justify-center py-3">
                            Success
                        </div> */}
                    </div>
                    <div className="flex-center flex flex-col items-center pt-s8 pb-8 md:pb-[42px]">
                        <p className="w-full text-center text text-lg font-semibold">
                            All your pending transactions<br/> have been successfully cancelled.
                        </p>
                    </div>
                </div>
                <div className="flex justify-center">
                    <RegularButton
                        variant={ButtonVariant.PrimaryDefault}
                        className="min-h-12 min-w-[185px] text-lg"
                        label="Invest Now"
                        noIcon={true}
                        showRightIcon={false}
                        onClick={onClose}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default CancelOrdersConfirmationModal;